/**
 * React Query hook for fetching epics
 * Story 198: View and filter stories in backlog
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

/** Epic list item from API */
export interface EpicListItem {
  id: string;
  slug: string;
  title: string;
  description: string | null;
  order_index: number;
  story_count: number;
}

/** Query key factory for epics */
export const epicKeys = {
  all: ['epics'] as const,
  list: (projectSlug: string) => [...epicKeys.all, 'list', projectSlug] as const,
};

/** Fetch epics for a project */
async function fetchEpics(projectSlug: string): Promise<EpicListItem[]> {
  const endpoint = `/api/v1/projects/${encodeURIComponent(projectSlug)}/epics`;
  const data = await api.fetch(endpoint);
  return data.epics;
}

/**
 * Hook to fetch epics for a project
 *
 * @param projectSlug - Project identifier (e.g., "boxabirds/claude-backlog")
 */
export function useEpics(projectSlug: string) {
  return useQuery({
    queryKey: epicKeys.list(projectSlug),
    queryFn: () => fetchEpics(projectSlug),
    enabled: !!projectSlug,
  });
}
